<template>
<div v-if="visible">
    <modal name="simulator" 
    :resizable="false" 
    :draggable="false" 
    :scrollable="true"
    :clickToClose="style.clickToClose"
    :width="style.width"
    :height="style.height"
    @closed="hide"
    @opened="opened">
      <div class="smart-iframe">
        <div class="head" v-if="title">
          <span class="headTitle">{{ title }}</span>    
          <i title="关闭" class="closeBtn i-close" @click="hide"></i>
        </div>
        <div class="frameOut" v-bind:class="{frameOut1:!title}">
          <iframe class="appframe" id="appframe" name="appframe" :src="frameUrl" @load="loaded" frameborder="0" scrolling="auto"></iframe>
        </div>
      </div>
    </modal>
</div>
</template>

<script>
import { getAllCookies } from "tiny-cookie";
import Vue from "vue";
import VModal from "vue-js-modal";
Vue.use(VModal);
export default {
  data() {
    return {
      inited: false,
      sendData: {},
      style: {
        clickToClose: false
      },
      frameUrl: "_blank",
      // handleMessage: function() {}
    };
  },
  props:{
    visible:{
      type:Boolean,
      default:false
    }
  },
  methods: {
    loaded: function() {
      if (this.inited) return;
      var frame = document.getElementById("appframe");
      var sessionData = {};
      Object.keys(sessionStorage).forEach(function(key) {
        sessionData[key] = sessionStorage[key];
      });
      var cookieData = getAllCookies();
      Object.assign(sessionData, cookieData);
      Object.assign(sessionData, this.sendData);
      console.log("session data", sessionData);
      frame.contentWindow.postMessage(
        { from: "simulator", sessionData: sessionData },
        "*"
      );
      this.inited = true;
    },
    opened: function() {
      // var frame = document.getElementById("appframe");
      window.addEventListener("message", this.receiveMessage);
    },
    receiveMessage: function(e) {
      if (!e.data || !e.data || e.data.from != "simulator") return;
      this.handleMessage(e.data);
      this.hide();
    },
    hide() {
      this.frameUrl = '';
      this.$modal.hide("simulator");
      this.visible = false;
    }
  }
};
</script>

<style>
  .smart-iframe{
    position: relative;
    width:100%;
    height:100%;
  }
  .frameOut{
    overflow:hidden;
    position:absolute;
    left:0;
    right:0;
    top:50px;
    bottom:0px;
  }
  .frameOut1{
    overflow:hidden;
    position:absolute;
    left:0;
    right:0;
    top:0px;
    bottom:0px;
  }
  .appframe{
    width:100%;
    height:100%;
  }
  .head{
    width:100%;
    height:50px;
    line-height: 50px;
    position: absolute;
    text-align:center;
    border-bottom:1px solid #dedede;
  }
  .headTitle{
      color:#2D8CF0;
      font-size:18px;
  }
  .closeBtn{
    position: absolute;
    right:20px;
    top:15px;
    cursor:pointer;
  }
  .i-close{
    display:inline-block;
    width:20px;
    height:20px;
    background:url("../../assets/images/close.svg");
    background-size:100%; 
  }
  .frameFoot{
    text-align: center;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    line-height: 50px;
    border-top: 1px solid #dedede;
  }
  .frameBtn{
    display: inline-block;
    min-width:60px;
    text-align:center;
    height:32px;
    line-height:30px;
    border-radius:4px;
    cursor:pointer;
    padding:0 4px 0 0;
    margin:0 10px 0 0;
  }
  .frameBtnSure{
    background:#2D8CF0;
    border:1px solid #2D8CF0;
    color:#ffffff;
  }
  .frameBtnFalse{
    border:1px solid #2D8CF0;
    color:#2D8CF0;
  }
</style>
